// src/routes.tsx

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Journey from './pages/Journey';
import Research from './pages/Research';
import Community from './pages/Community';
import Resume from './pages/Resume';
import ResumePrivate from './pages/Resume/ResumePrivate';
import HealthReportGenerator from './pages/Tools/HealthReportGenerator';
import CtankHealthSummary from './pages/Tools/CtankHealthSummary';
import RachitNintendoQuest from './pages/Tools/RachitNintendoQuest';
import OuraDashboard from './pages/Tools/OuraDashboard';
import RachitQuiz from './pages/Quiz/RachitQuiz';
import ParidhiQuiz from './pages/Quiz/ParidhiQuiz';

import { MainLayout } from './layouts/MainLayout';
import ContactPage from './pages/Contact';

const AppRoutes = () => (
  <Routes>
    {/* Full-screen Nintendo Quest without header */}
    <Route path="/tools/rachit-nintendo" element={<RachitNintendoQuest />} />
    {/* Full-screen quiz routes without header */}
    <Route path="/quiz/rachit" element={<RachitQuiz />} />
    <Route path="/quiz/paridhi" element={<ParidhiQuiz />} />
    
    {/* All other routes with MainLayout header */}
    <Route path="/*" element={
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/journey" element={<Journey />} />
          <Route path="/research" element={<Research />} />
          <Route path="/community" element={<Community />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/resume-private" element={<ResumePrivate />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/tools/health-log" element={<Navigate to="/tools/health/report" replace />} />
          <Route path="/tools/health/report" element={<HealthReportGenerator />} />
          <Route path="/tools/ctank-health-log" element={<Navigate to="/tools/health/ctank-summary" replace />} />
          <Route path="/tools/health/ctank-summary" element={<CtankHealthSummary />} />
          <Route path="/tools/health/oura" element={<OuraDashboard />} />
        </Routes>
      </MainLayout>
    } />
  </Routes>
);

export default AppRoutes;